





































































/* tslint:disable:only-arrow-functions*/

import {Component, Vue} from 'vue-property-decorator';
import getFileSizeHumanReadable from '@/util/file-size';
import AnimatedInput from '@/components/AnimatedInput.vue';
import LoadingButton from '@/components/LoadingButton.vue';
import Letterbox from "../models/Letterbox";
import Metadata from "../models/Metadata";
import DownloadHandle from "../util/DownloadHandle";
import LetterboxAdapter from "../adapters/letterbox";
import KeyUtility from "../util/keyUtility";
import * as Sentry from '@sentry/browser';
import featureFlags from "@/util/featureFlags";
import store from "@/store";
import {Action, State} from "vuex-class";
import AccountDataAES from "@/util/accountDataAES";
import Base64Encoder from "@/util/base64encoder";
import EncryptedFile from "@/models/EncryptedFile";
import dayjs from "@/util/dayjs";

@Component({
    components: {AnimatedInput, LoadingButton},
})
export default class LetterboxContent extends Vue {

    adapter = new LetterboxAdapter();
    letterboxInfo: Letterbox | null = null;
    errorMessage: string | null = null;
    urlMaterial: string = "";
    letterboxUploadLink: string = "";
    letterboxContent: Map<string, Metadata>  = new Map();
    letterBoxUploadDate: Map<string, string> = new Map();
    fileIds: string[] = [];

    @Action fetchMyLetterboxes!: () => Promise<void>;
    @State(state => state.account.myLetterboxes) myLetterboxes!: Letterbox[];

    fileById(id: string): Metadata | null {
        const file: Metadata | undefined = this.letterboxContent.get(id);
        return file ? file : null;
    }

    fileLink(id: string): string {
        const idAndKey = id + '#' + this.urlMaterial;
        return featureFlags.frontendBaseUrl + "/download/" + idAndKey;
    }

    fileDate(id: string) {
      return this.letterBoxUploadDate.get(id);
    }

    fileCount(id: string): string {
      const file: Metadata | null = this.fileById(id);
      if (!file) {
        return "Unbekannt";
      }

      if (file.files) {
        if (file.files.length === 1) {
          return "Eine Datei";
        } else {
          return `${file.files.length} Dateien`;
        }
      } else {
        return "Eine Datei";
      }
    }

    fileNames(id: string): string[] {
      const file: Metadata | null = this.fileById(id);
      if (!file) {
        return ["Unbekannt"];
      }

      if (file.files) {
        return file.files.map((encFile: EncryptedFile) => encFile.name);
      } else {
        return [file.filename];
      }
    }

    fileSize(id: string): string | number {
        const file: Metadata | null = this.fileById(id);
        if (!file) {
          return 0;
        }

        if (file.files) {
          let size = 0;
          for (const f of file.files) {
            size += f.size;
          }
          return getFileSizeHumanReadable(size);
        } else {
          return getFileSizeHumanReadable(file.filesize);
        }
    }

    created() {
        return this.downloadInfo();
    }

    async downloadInfo() {
        try {
            const id = this.$route.params.id;
            let keyMaterial = this.$route.hash;

            if (keyMaterial === '') {
                //check if logged in and get the secret:
                if (this.$store.getters.isLoggedIn) {
                  await this.fetchMyLetterboxes();
                  const found: Letterbox | undefined = this.myLetterboxes.find((l: Letterbox) => {
                    return l.id === id;
                  });
                  if (found) {
                    const accountEncryption: AccountDataAES = await AccountDataAES.fromAccountData(store.state.account.masterKey, store.state.account.accountData);
                    const iv: Uint8Array = Base64Encoder.stringToBytes(found.secretEncryptedIv);
                    keyMaterial = encodeURIComponent(await accountEncryption.decryptStringFromBase64Encoded(found.secretEncrypted, iv));
                  } else {
                    this.$swal('Ein Fehler trat auf', 'Der Link war nicht korrekt.', 'error');
                    return;
                  }
                } else {
                  //http://localhost:8080/letterbox/3c693788-79bf-4431-8af3-af6c83a0ea54/download
                  const routeToPush = '/?loginandgoto=' + this.$route.path;
                  this.$router.push({ path: '/', query: { loginandgoto: this.$route.path }});
                  return;
                }
            }

            if (keyMaterial.startsWith('#')) {
                keyMaterial = keyMaterial.substring(1); //remove leading #
            }
            this.urlMaterial = keyMaterial;

            const encryptedInfo = await this.adapter.openLetterbox(id);

            const b64Key: string = decodeURIComponent(this.urlMaterial);
            const key: CryptoKey = await KeyUtility.loadKeyFromBase64(b64Key);

            this.letterboxInfo = await encryptedInfo.getDecrypted(key);

            const baseUrl: string = featureFlags.frontendBaseUrl + '/letterbox/';
            this.letterboxUploadLink = baseUrl + this.letterboxInfo.uploadKey + '/upload#' + this.urlMaterial;
            for (const upload of this.letterboxInfo.uploads) {
                try {
                    const downloadHandle = DownloadHandle.fromUpload(upload);
                    await downloadHandle.decryptMetadataWithKeyFromUrl(this.urlMaterial);
                    const metaData = downloadHandle.getMeta();
                    const date = dayjs(upload.created);
                    this.letterboxContent.set(upload.id, metaData);
                    this.letterBoxUploadDate.set(upload.id, date.format('DD. MMMM YYYY [um] HH:mm'));
                    this.fileIds.push(upload.id);
                } catch (e) {
                    Vue.$log.error("File could not be decrypted", e);
                    Sentry.captureException(e);
                }
            }
        } catch (e) {
            Vue.$log.error("Letterbox info could not be downloaded, exception was thrown", e);
            this.errorMessage = "Der Briefkasten-Inhalt konnte nicht abgerufen werden.";
            //this.$swal('Ein Fehler trat auf', 'Briefkasten-Inhalt konnte nicht abgerufen werden.', 'error');
            Sentry.captureException(e);
            return;
        }
    }

    async startOver() {
        await this.downloadInfo();
    }

    copyUploadLinkToClipboard() {
        if (this.letterboxUploadLink) {
            const copyText: HTMLInputElement = document.createElement("input");
            document.body.appendChild(copyText);
            copyText.value = this.letterboxUploadLink;
            copyText.select();
            document.execCommand("copy");
            document.body.removeChild(copyText);
            this.$swal('Erfolg', 'Du kannst den Link z.B. über ' +
                'einen verschlüsselten Messenger verschicken.', 'success');
        }
    }
}
